import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  CommonErrorMsg,
  confirmDelete,
  ErrorMsg,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../../Util/common";
import { KendoGrid } from "../../../Kendo/kendo_grid";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../../Util/axios_core_helper";
import { KendoLoader } from "../../../Kendo/kendo_loader";
import { toast } from "react-toastify";
import { KendoTreeTable } from "../../../Kendo/kendo_treetable";

const RentalCategory = () => {
  const modalRef = useRef(null);
  const ItemmodalRef = useRef(null);
  const [editVisible, setEditVisible] = useState(false);
  const [Dup, setDup] = useState(false);
  const [ItemDup, setItemDup] = useState(false);
  const [OverSize, setOverSize] = useState(false);
  const [error, setError] = useState({});
  const [Loading, setLoading] = useState(false);
  const [CategoryList, setCategoryList] = useState([]);
  const [ItemList, setItemList] = useState([]);
  const [refreshflag, setrefreshflag] = useState(0);
  const [imageList, setImageList] = useState([]);
  const [selectedImageID, setSelectedImageID] = useState(null);
  const imageListRef = useRef(imageList);
  const [dragging, setDragging] = useState(null);
  const [ytLink, setytLink] = useState(false);
  const [Category, setCategory] = useState({
    categoryID: 0,
    categoryName: "",
    image: "",
    popular: "",
    imagePath: "",
  });

  const [Item, setItem] = useState({
    categoryID: 0,
    itemID: 0,
    itemName: "",
    rate: "",
    quantity: "",
    youtubeLink: "",
    description: "",
    images: [],
    oldImages: [],
  });

  const Parentscolumns = [
    {
      field: "categoryID",
      filterable: false,
      hidden: true,
    },
    {
      field: "categoryName",
      title: "Category Name",
      width: 150,
    },
    {
      template: function (e) {
        if (e.imagePath) {
          return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
        }
        return "";
      },

      title: "Image",
      width: 50,
    },
    {
      field: "isPopular",
      title: "Is Popular",
      width: 50,
      template: function (e) {
        return `
          <label class="switch">
            <input 
              type="checkbox" 
              ${e.isPopular == true ? "checked" : ""} 
              data-id="${e.categoryID}"
              class="status-toggle"
            />
            <span class="slider round"></span>
          </label>`;
      },
    },
  ];

  const childColumn = [
    {
      field: "itemID",
      hidden: true,
    },
    {
      field: "categoryID",
      hidden: true,
    },
    {
      field: "itemName",
      title: "Item Name",
      width: 100,
    },
    {
      template: function (e) {
        if (e.youtubeLink) {
          return `<a href="${e.youtubeLink}" target="_blank">${e.youtubeLink}</a>`;
        }
        return "";
      },
      title: "Youtube Link",
      width: 50,
    },
  ];

  const handleToggleClick = async (id, newStatus) => {
    await corefetch(
      `Rental/UpdateRCategoryPoular?CategoryID=${id}&Ispopular=${newStatus}&ModifiedBy=${sessionUser()}`,
      true,
      false,
      false,
      true
    );
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (event.target.classList.contains("status-toggle")) {
        const id = event.target.getAttribute("data-id");
        const newStatus = event.target.checked ? true : false;
        handleToggleClick(id, newStatus);
      }
    };
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const onSubmit = async (e) => {
    e.preventDefault();

    const err = ValidateForm(e);
    if (err && !OverSize) {
      setError(err);
    } else if (!OverSize && !Dup) {
      setLoading(true);
      const formData = new FormData();
      formData.append("CategoryID", Category.categoryID);
      formData.append("CategoryName", Category.categoryName);
      formData.append("ImagePath", Category.imagePath);
      formData.append("SavedBy", sessionUser());
      if (Category.image) {
        formData.append("Image", Category.image);
      }

      try {
        await corepost(
          "Rental/InsertUpdateRCategory",
          formData,
          true,
          true,
          false,
          false
        );
        setrefreshflag(refreshflag + 1);
        fetchData();
        clearForm();
        $("#Category-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const clearForm = () => {
    setLoading(false);
    $("#hide").click();
    setCategory({
      categoryID: 0,
      categoryName: "",
      image: "",
      popular: "",
      imagePath: "",
    });
    setError({});
    setDup(false);
    setEditVisible(false);

    const form = document.getElementById("form-category-config");
    if (form) {
      form.reset();
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }

    const InvalidFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (InvalidFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      setOverSize(false);
      setCategory((prev) => ({
        ...prev,
        image: "",
      }));
      return;
    }

    if (!file) {
      setOverSize(false);
      setCategory((prev) => ({
        ...prev,
        image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;
      setOverSize(isFileTooLarge);

      if (!isFileTooLarge) {
        let temp = Category;
        temp.image = file;
        setCategory(temp);
        document.getElementById("image-name").value = file;
      }
      onValidation("Image", e.target.value);
    }
  };

  const fetchData = async () => {
    try {
      const list = await corefetch("Rental/GetRentalCategoryDetails");
      setCategoryList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const onParentEditClick = async (e) => {
    let temp = Category;
    Category.categoryID = e.categoryID;
    Category.categoryName = e.categoryName;
    Category.image = e.imagePath;
    Category.imagePath = e.imagePath;
    setCategory(temp);
    setEditVisible(true);

    const modal = new bootstrap.Modal(document.getElementById("add_Category"));
    modal.show();
  };

  const handleParentDeleteClick = (e) => {
    const onDelete = async () => {
      // Step 1: Check if the category is mapped
      const isMapped = await corefetch(
        `Rental/GetCategoryMappingDetails?categoryId=${e.categoryID}`,
        true
      );

      // Step 2: If mapped, show a toast and do not delete
      if (isMapped) {
        toast.error("Category is mapped with item and cannot be deleted.");
        return;
      } else {
        corefetch(
          `Rental/DeleteRCategory?CategoryID=${
            e.categoryID
          }&DeletedBy=${sessionUser()}`,
          true,
          false,
          true
        ).then(() => {
          fetchData();
          setrefreshflag((prev) => prev + 1);
        });
      }

      // Step 3: If not mapped, proceed with deletion
    };

    confirmDelete(onDelete);
  };

  const onItemAdd = async (e) => {
    setItem((prev) => ({
      ...prev,
      categoryID: e.categoryID,
    }));
    const modal = new bootstrap.Modal(document.getElementById("add_Item"));
    modal.show();
  };

  const onItemSubmit = async (e) => {
    e.preventDefault();
    const err = ValidateForm(e);
    if (err && !OverSize) {
      setError(err);
    } else if (!OverSize && !Dup) {
      setLoading(true);
      const formData = new FormData();
      formData.append("CategoryID", Category.categoryID);
      formData.append("CategoryName", Category.categoryName);
      formData.append("ImagePath", Category.imagePath);
      formData.append("SavedBy", sessionUser());
      if (Category.image) {
        formData.append("Image", Category.image);
      }

      try {
        await corepost(
          "Rental/InsertUpdateRCategory",
          formData,
          true,
          true,
          false,
          false
        );
        setrefreshflag(refreshflag + 1);
        fetchData();
        clearForm();
        $("#Category-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const clearItemForm = () => {
    setLoading(false);
    $("#hide").click();
    setItem({
      categoryID: 0,
      itemID: 0,
      itemName: "",
      rate: "",
      quantity: "",
      description: "",
      images: [],
      oldImages: [],
    });
    setImageList([]);
    setError({});
    setDup(false);
    setEditVisible(false);

    const form = document.getElementById("form-item-config");
    if (form) {
      form.reset();
    }
  };

  const handleItemFileChange = (event) => {
    const files = Array.from(event.target.files);
    const validImages = files.filter((file) => file.type.startsWith("image/"));
    const hasAvifFile = files.some(
      (file) => file.type === "image/avif" || file.name.endsWith(".avif")
    );

    if (hasAvifFile) {
      toast.error("Uploaded images contain unsupported formats.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (files.length == 0 && imageList.length == 0) {
      onValidation("Image", event.target.value);
      return;
    }
    if (validImages.length !== files.length) {
      setError({ ValidFile: true });
    } else if (files.length != 0) {
      const newImageList = validImages.map((file, index) => ({
        imagePath: URL.createObjectURL(file),
        fileName: file.name,
        fileData: file,
        Id: index,
        selectedAsCover: false,
        Images: validImages,
        isCoverPhoto: 0,
      }));

      setImageList((prevImages) => [...prevImages, ...newImageList]);
      setItem((prevState) => ({
        ...prevState,
        images: prevState.images
          ? [...prevState.images, ...validImages]
          : [...validImages],
      }));
      event.target.value = "";
    }
  };

  const handleRemoveImage = (imageId, index) => {
    try {
      const wasCoverPhoto = imageList[index]?.isCoverPhoto === 1;
      const updatedImageList = imageList.filter((_, i) => i !== index);

      if (wasCoverPhoto && updatedImageList.length > 0) {
        // If the removed image was the cover photo, assign the first image as the new cover photo
        updatedImageList[0].isCoverPhoto = 1;
        setSelectedImageID(updatedImageList[0].imageID || 0); // Update selectedImageID
      }

      setImageList(updatedImageList);

      setRemovedImageIds((prevRemovedIds = "") =>
        [...prevRemovedIds.split(","), imageId].filter(Boolean).join(",")
      );

      setItem((prevGallery) => ({
        ...prevGallery,
        images: updatedImageList.map((item) => item.fileData || item),
      }));
    } catch (error) {
      console.error("Error removing image:", error);
    }
  };

  useEffect(() => {
    imageListRef.current = imageList;
  }, [imageList]);

  const handleImageSelect = (img, index) => {
    try {
      const updatedImageList = imageList.map((image, idx) => ({
        ...image,
        isCoverPhoto: idx === index ? 1 : 0,
      }));

      setImageList(updatedImageList);

      setSelectedImageID(img.imageID || index);

      refreshChildGrd();
    } catch (error) {
      console.error("Error selecting image:", error);
    }
  };

  const handleDragStart = (e, index) => {
    setDragging(index);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, index) => {
    const newList = [...imageList];
    const draggedItem = newList.splice(dragging, 1)[0];
    newList.splice(index, 0, draggedItem);
    newList.forEach((item, newIndex) => {
      item.SortOrder = newIndex + 1;
    });
    setImageList(newList);
    setItem((prevGallery) => ({
      ...prevGallery,
      images: newList.map((item) => item.fileData || item),
    }));
    setDragging(null);
  };

  const onRowReorderChange = async (List) => {
    let ID = $(List.newRow).find("td").eq(0).text();
    let oldSortId = $(List.newRow).find("td").eq(1).text();
    let newSortId = $(List.oldRow).find("td").eq(1).text();
    await corefetch(
      `Rental/SortCategorySection?TypeId=${ID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
    );
    setrefreshflag(refreshflag + 1);
  };

  return (
    <>
      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_Category"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <i>
                <span style={{ backgroundColor: "yellow" }}>Note:</span>
                This module supports drag-and-drop functionality, you can easily
                rearrange or move data as needed
              </i>
              <KendoGrid
                name={"RentalCategory"}
                url={CorebaseURL + "Rental/GetRentalCategoryDetails"}
                schema={{}}
                columns={[
                  {
                    field: "categoryID",
                    filterable: false,
                    hidden: true,
                  },
                  { field: "orderBy", hidden: true },
                  {
                    field: "categoryName",
                    title: "Category Name",
                    width: 150,
                  },
                  {
                    template: function (e) {
                      if (e.imagePath) {
                        return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
                      }
                      return "";
                    },

                    title: "Image",
                    width: 50,
                  },
                  {
                    field: "isPopular",
                    title: "Is Popular",
                    width: 50,
                    template: function (e) {
                      return `
                        <label class="switch">
                          <input 
                            type="checkbox" 
                            ${e.isPopular == true ? "checked" : ""} 
                            data-id="${e.categoryID}"
                            class="status-toggle"
                          />
                          <span class="slider round"></span>
                        </label>`;
                    },
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={(e) => onParentEditClick(e)}
                onDeleteClick={(e) => {
                  handleParentDeleteClick(e);
                }}
                paggable={true}
                disableExportExcel={true}
                height={"60vh"}
                refreshWhen={refreshflag}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* <!-- Add Category Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_Category"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered VendorServices"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {editVisible ? "Edit Category" : "Add Category"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-category-config" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="ID"
                  value={Category.categoryID || 0}
                />

                {/* Single Column Layout */}
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Category Name<span className="text-danger">*</span>{" "}
                        <InfoIcon content="Please provide a Category Name with a maximum length of 50 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={50}
                        className="form-control field"
                        name="CategoryName"
                        value={Category.categoryName || ""}
                        placeholder="Category Name"
                        data-required="true"
                        onChange={(e) => {
                          setCategory((prev) => ({
                            ...prev,
                            categoryName: e.target.value,
                          }));
                          onValidation("CategoryName", e.target.value);
                          let dup;
                          if (Category.categoryID > 0) {
                            const matchingItem = CategoryList.find(
                              (item) =>
                                item.categoryName.trim().toLowerCase() ==
                                  e.target.value.trim().toLowerCase() &&
                                item.categoryID != Category.categoryID
                            );

                            dup = matchingItem;
                            setDup(dup);
                          } else {
                            const matchingItem = CategoryList.find(
                              (item) =>
                                item.categoryName.trim().toLowerCase() ==
                                e.target.value.trim().toLowerCase()
                            );
                            dup = matchingItem;
                            setDup(dup);
                          }
                        }}
                      />
                      {error.CategoryName && (
                        <ErrorMsg text="Category Name is required." />
                      )}
                      {Dup && (
                        <ErrorMsg text="Category Name is already exist." />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Upload Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="Kindly upload an Image within 500KB size,
                              Please upload the image in JPEG or JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                      {error.Image && <ErrorMsg text=" Image is required" />}
                      {error.ValidFile && (
                        <ErrorMsg text="please upload Image file only" />
                      )}
                      {OverSize && (
                        <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    {Category.imagePath && Category.categoryID > 0 && (
                      <div
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={`${ImageURL}${Category.imagePath}`}
                          target="_blank"
                          style={{
                            textDecoration: "underline",
                            fontSize: "13px",
                          }}
                        >
                          {Category.imagePath.split("/").pop()}
                        </a>
                      </div>
                    )}
                    <input
                      type="hidden"
                      name="Image"
                      id="image-name"
                      data-required="true"
                      value={Category.image || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={Category.imagePath}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="Category-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add Category Modal --> */}
    </>
  );
};

export default RentalCategory;
